module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_vm._v("CHAPTER III")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Early in January was the Annual College Y.M.C.A. Week of Prayer. It was a countrywide event, but in Terwillinger College it was of especial power that year because they were privileged to have with them for three days none other than Judson Roberts, State Secretary of the Y.M.C.A., and a man great personally as well as officially.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was young, Mr. Roberts, only thirty-four, but already known throughout the land. He had always been known. He had been a member of a star University of Chicago football team, he had played varsity baseball, he had been captain of the debating team, and at the same time he had commanded the Y.M.C.A. He had been known as the Praying Fullback. He still kept up his exercise—he was said to have boxed privily with Jim Jefferies—and he had mightily increased his praying. A very friendly leader he was, and helpful; hundreds of college men throughout Kansas called him “Old Jud.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Between prayer-meetings at Terwillinger, Judson Roberts sat in the Bible History seminar-room, at a long table, under a bilious map of the Holy Land, and had private conferences with the men students. A surprising number of them came edging in, trembling, with averted eyes, to ask advice about a secret practice, and Old Jud seemed amazingly able to guess their trouble before they got going.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, now, old boy, I’ll tell you. Terrible thing, all right, but I’ve met quite a few cases, and you just want to buck up and take it to the Lord in prayer. Remember that he is able to help unto the uttermost. Now the first thing you want to do is to get rid of—I’m afraid that you have some pretty nasty pictures and maybe a juicy book hidden away, now haven’t you, old boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("How could Old Jud have guessed? What a corker!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s right. I’ve got a swell plan, old boy. Make a study of missions, and think how clean and pure and manly you’d want to be if you were going to carry the joys of Christianity to a lot of poor gazebos that are under the evil spell of Buddhism and a lot of these heathen religions. Wouldn’t you want to be able to look ‘em in the eye, and shame ‘em? Next thing to do is to get a lot of exercise. Get out and run like hell! And then cold baths. Darn’ cold. There now!” Rising, with ever so manly a handshake: “Now, skip along and remember”—with a tremendous and fetching and virile laugh—”just run like hell!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim and Elmer heard Old Jud in chapel. He was tremendous. He told them a jolly joke about a man who kissed a girl, yet he rose to feathered heights when he described the beatitude of real ungrudging prayer, in which a man was big enough to be as a child. He made them tearful over the gentleness with which he described the Christchild, wandering lost by his parents, yet the next moment he had them stretching with admiration as he arched his big shoulder-muscles and observed that he would knock the block off any sneering, sneaking, lying, beer-bloated bully who should dare to come up to him in a meeting and try to throw a monkey-wrench into the machinery by dragging out a lot of contemptible, quibbling, atheistic, smart-aleck doubts! (He really did, the young men glowed, use the terms “knock the block off,” and “throw a monkey-wrench.” Oh, he was a lulu, a real red-blooded regular fellow!)")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim was coming down with the grippe. He was unable to pump up even one good sneer. He sat folded up, his chin near his knees, and Elmer was allowed to swell with hero-worship. Golly! He’d thought he had some muscle, but that guy Judson Roberts—zowie, he could put Elmer on the mat seven falls out of five! What a football player he must have been! Wee!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This Homeric worship he tried to explain to Jim, back in their room, but Jim sneezed and went to bed. The rude bard was left without audience and he was practically glad when Eddie Fislinger scratched at the door and edged in.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t want to bother you fellows, but noticed you were at Old Jud’s meeting this afternoon and, say, you gotta come out and hear him again tomorrow evening. Big evening of the week. Say, honest, Hell-cat, don’t you think Jud’s a real humdinger?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, I gotta admit, he’s a dandy fellow.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Say, he certainly is, isn’t he! He certainly is a dandy fellow, isn’t he! Isn’t he a peach!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, he certainly is a peach—for a religious crank!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aw now, Hell-cat, don’t go calling him names! You’ll admit he looks like some football shark.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, I guess he does, at that. I’d liked to of played with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Wouldn’t you like to meet him?’“")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At this moment of danger, Jim raised his dizzy head to protest, “He’s a holy strikebreaker! One of these thick-necks that was born husky and tries to make you think he made himself husky by prayer and fasting. I’d hate to take a chance on any poor little orphan nip of Bourbon wandering into Old Jud’s presence! Yeh! Chest-pounder! ‘Why can’t you hundred-pound shrimps be a big manly Christian like me!’“")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Together they protested against this defilement of the hero, and Eddie admitted that he had ventured to praise Elmer to Old Jud; that Old Jud had seemed enthralled; that Old Jud was more than likely—so friendly a Great Man was he—to run in on Elmer this afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Before Elmer could decide whether to be pleased or indignant, before the enfeebled Jim could get up strength to decide for him, the door was hit a mighty and heroic wallop, and in strode Judson Roberts, big as a grizzly, jolly as a spaniel pup, radiant as ten suns.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He set upon Elmer immediately. He had six other doubting Thomases or suspected smokers to dispose of before six o’clock.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was a fair young giant with curly hair and a grin and with a voice like the Bulls of Bashan whenever the strategy called for manliness. But with erring sisters, unless they were too erring, he could be as lulling as woodland violets shaken in the perfumed breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hello, Hell-cat!” he boomed. “Shake hands!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer had a playful custom of squeezing people’s hands till they cracked. For the first time in his life his own paw felt limp and burning. He rubbed it and looked simple.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Been hearing a lot about you, Hell-cat, and you, Jim. Laid out, Jim? Want me to trot out and get a doc?” Old Jud was sitting easily on the edge of Jim’s bed, and in the light of that grin, even Jim Lefferts could not be very sour as he tried to sneer, “No, thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Roberts turned to Elmer again, and gloated:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, old son, I’ve been hearing a lot about you. Gee whillikins, that must have been a great game you played against Thorvilsen College! They tell me when you hit that line, it gave like a sponge, and when you tackled that big long Swede, he went down like he’d been hit by lightning.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, it was—it was a good game.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Course I read about it at the time—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did you, honest?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“—and course I wanted to hear more about it, and meet you, Hell-cat, so I been asking the boys about you, and say, they certainly do give you a great hand! Wish I could’ve had you with me on my team at U of Chi—we needed a tackle like you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer basked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, sir, the boys all been telling me what a dandy fine fellow you are, and what a corking athlete, and what an A-1 gentleman. They all say there’s just one trouble with you, Elmer lad.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They say you’re a coward.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Heh? Who says I’m a coward?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Judson Roberts swaggered across from the bed, stood with his hand on Elmer’s shoulder. “They all say it, Hell-cat! You see it takes a sure-enough dyed-in-the-wool brave man to be big enough to give Jesus a shot at him, and admit he’s licked when he tries to fight God! It takes a man with guts to kneel down and admit his worthlessness when all the world is jeering at him! And you haven’t got that kind of courage, Elmer. Oh, you think you’re such a big cuss—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Old Jud swung him around; Old Jud’s hand was crushing his shoulder. “You think you’re too husky, too good, to associate with the poor little sniveling gospel-mongers, don’t you! You could knock out any of ‘em, couldn’t you! Well, I’m one of ‘em. Want to knock me out?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("With one swift jerk Roberts had his coat off, stood with a striped silk shirt revealing his hogshead torso.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You bet, Hell-cat! I’m willing to fight you for the glory of God! God needs you! Can you think of anything finer for a big husky like you than to spend his life bringing poor, weak, sick, scared folks to happiness? Can’t you see how the poor little skinny guys and all the kiddies would follow you and praise you and admire you, you old son of a gun? Am I a sneaking Christian? Can you lick me? Want to fight it out?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, gee, Mr. Roberts—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Judson, you big hunk of cheese, Old Jud!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, gee, Judson, I guess you got me trimmed! I pack a pretty good wallop, but I’m not going to take any chance on you!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right, old son. Still think that all religious folks are crabs?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And weaklings and pikers?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And liars?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, no.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right, old boy. Going to allow me to be a friend of yours, if I don’t butt in on your business?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, gee, sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Then there’s just one favor I want to ask. Will you come to our big meeting tomorrow night? You don’t have to do a thing. If you think we’re four-flushers—all right; that’s your privilege. Only will you come and not decide we’re all wrong beforehand, but really use that big fine incisive brain of yours and study us as we are? Will you come?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, yes, sure, you bet.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Fine, old boy. Mighty proud to have you let me come butting in here in this informal way. Remember: if you honestly feel I’m using any undue influence on the boys, you come right after me and say so, and I’ll be mighty proud of your trusting me to stand the gaff. So long, old Elm! So long, Jim. God bless you!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So long, Jud.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was gone, a whirlwind that whisked the inconspicuous herb Eddie Fislinger out after it. And then Jim Lefferts spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For a time after Judson Roberts’ curtain, Elmer stood glowing, tasting praise. He was conscious of Jim’s eyes on his back, and he turned toward the bed, defiantly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They stared, in a tug of war. Elmer gave in with a furious:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, then, why didn’t you say something while he was here?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“To him? Talk to a curly wolf when he smells meat? Besides, he’s intelligent, that fellow.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, say, I’m glad to hear you say that, because—well, you see—I’ll explain how I feel.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, no, you won’t, sweetheart! You haven’t got to the miracle-pulling stage yet. Sure he’s intelligent. I never heard a better exhibition of bunco-steering in my life. Sure! He’s just crazy to have you come up and kick him in the ear and tell him you’ve decided you can’t give your imprimatur—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“—to his show, and he’s to quit and go back to hod-carrying. Sure. He read all about your great game with Thorvilsen. Sent off to New York to get the Review of Reviews and read more about it. Eddie Fislinger never told him a word. He read about your tackling in the London Times. You bet. Didn’t he say so? And he’s a saved soul—he couldn’t lie. And he just couldn’t stand it if he didn’t become a friend of yours. He can’t know more than a couple of thousand collidge boys to spring that stuff on! … You bet I believe in the old bearded Jew God! Nobody but him could have made all the idiots there are in the world!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Gee, Jim, honest, you don’t understand Jud.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. I don’t. When he could be a decent prize-fighter, and not have to go around with angleworms like Eddie Fislinger day after day!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And thus till midnight, for all Jim’s fevers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But Elmer was at Judson Roberts’ meeting next evening, unprotected by Jim, who remained at home in so vile a temper that Elmer had sent in a doctor and sneaked away from the room for the afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was undoubtedly Eddie who wrote or telegraphed to Mrs. Gantry that she would do well to be present at the meeting. Paris was only forty miles from Gritzmacher Springs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer crept into his room at six, still wistfully hoping to have Jim’s sanction, still ready to insist that if he went to the meeting he would be in no danger of conversion. He had walked miles through the slush, worrying. He was ready now to give up the meeting, to give up Judson’s friendship, if Jim should insist.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As he wavered in, Mrs. Gantry stood by Jim’s lightning-shot bed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why, Ma! What you doing here? What’s gone wrong?” Elmer panted.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was impossible to think of her taking a journey for anything less than a funeral.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cozily, “Can’t I run up and see my two boys if I want to, Elmy? I declare, I believe you’d of killed Jim, with all this nasty tobacco air, if I hadn’t come in and aired the place out. I thought, Elmer Gantry, you weren’t supposed to smoke in Terwillinger! By the rules of the college! I thought, young man, that you lived up to ‘em! But never mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Uneasily—for Jim had never before seen him demoted to childhood, as he always was in his mother’s presence—Elmer grumbled, “But honest, Ma, what did you come up for?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, I read about what a nice week of prayer you were going to have, and I thought I’d just like to hear a real big bug preach. I’ve got a vacation coming, too! Now don’t you worry one mite about me. I guess I can take care of myself after all these years! The first traveling I ever done with you, young man—the time I went to Cousin Adeline’s wedding—I just tucked you under one arm—and how you squalled, the whole way!—mercy, you liked to hear the sound of your own voice then just like you do now!—and I tucked my old valise under the other, and off I went! Don’t you worry one mite about me. I’m only going to stay over the night—got a sale on remnants starting—going back on Number Seven tomorrow. I left my valise at that boarding-house right across from the depot. But there’s one thing you might do if ‘tain’t too much trouble, Elmy. You know I’ve only been up here at the college once before. I’d feel kind of funny, country bumpkin like me, going alone to that big meeting, with all those smart professors and everybody there, and I’d be glad if you could come along.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Of course he’ll go, Mrs. Gantry,” said Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But before Elmer was carried away, Jim had the chance to whisper, “God, do be careful! Remember I won’t be there to protect you! Don’t let ‘em pick on you! Don’t do one single doggone thing they want you to do, and then maybe you’ll be safe!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As he went out, Elmer looked back at Jim. He was shakily sitting up in bed, his eyes imploring.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The climactic meeting of the Annual Prayer Week, to be addressed by President Quarles, four ministers, and a rich trustee who was in the pearl-button business, with Judson Roberts as star soloist, was not held at the Y.M.C.A. but at the largest auditorium in town, the Baptist Church, with hundreds of town-people joining the collegians.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The church was a welter of brownstone, with Moorish arches and an immense star-shaped window not yet filled with stained glass.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer hoped to be late enough to creep in inconspicuously, but as his mother and he straggled up to the Romanesque portico, students were still outside, chattering. He was certain they were whispering, “There he is—Hell-cat Gantry. Say, is it really true he’s under conviction of sin? I thought he cussed out the church more’n anybody in college.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Meek though Elmer had been under instruction by Jim and threats by Eddie and yearning by his mother, he was not normally given to humility, and he looked at his critics defiantly. “I’ll show ‘em! If they think I’m going to sneak in—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He swaggered down almost to the front pews, to the joy of his mother, who had been afraid that as usual he would hide in the rear, handy to the door if the preacher should become personal.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was a great deal of decoration in the church, which had been endowed by a zealous alumnus after making his strike in Alaskan boarding-houses during the gold-rush. There were Egyptian pillars with gilded capitals, on the ceiling were gilt stars and clouds more woolen than woolly, and the walls were painted cheerily in three strata—green, watery blue, and khaki. It was an echoing and gaping church, and presently it was packed, the aisles full. Professors with string mustaches and dog-eared Bibles, men students in sweaters or flannel shirts, earnest young women students in homemade muslin with modest ribbons, over-smiling old maids of the town, venerable saints from the back-country with beards which partly hid the fact that they wore collars without ties, old women with billowing shoulders, irritated young married couples with broods of babies who crawled, slid, bellowed, and stared with embarrassing wonder at bachelors.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Five minutes later Elmer would not have had a seat down front. Now he could not escape. He was packed in between his mother and a wheezing fat man, and in the aisle beside his pew stood evangelical tailors and ardent school-teachers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The congregation swung into “When the Roll Is Called Up Yonder” and Elmer gave up his frenzied but impractical plans for escape. His mother nestled happily beside him, her hand proudly touching his sleeve, and he was stirred by the march and battle of the hymn:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When the trumpet of the Lord shall sound, and time shall be no more,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And the morning breaks eternal, bright and far.—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They stood for the singing of “Shall We Gather at the River?” Elmer inarticulately began to feel his community with these humble, aspiring people—his own prairie tribe: this gaunt carpenter, a good fellow, full of friendly greetings; this farm-wife, so courageous, channeled by pioneer labor; this classmate, an admirable basket-ball player, yet now chanting beatifically, his head back, his eyes closed, his voice ringing. Elmer’s own people. Could he be a traitor to them, could he resist the current of their united belief and longing?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Yes, we’ll gather at the river,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The beautiful, the beautiful river,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gather with the saints at the river")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That flows by the throne of God.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Could he endure it to be away from them, in the chill void of Him Lefferts’ rationalizing, on that day when they should be rejoicing in the warm morning sunshine by the river rolling to the imperishable Throne?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And his voice—he had merely muttered the words of the first hymn—boomed out ungrudgingly:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Soon our pilgrimage will cease; Soon our happy hearts will quiver With the melody of peace.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His mother stroked his sleeve. He remembered that she had maintained he was the best singer she had ever heard; that Jim Lefferts had admitted, “You certainly can make that hymn dope sound as if it meant something.” He noted that people near by looked about with pleasure when they heard his Big Ben dominate the cracked jangling.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The preliminaries merely warmed up the audience for Judson Roberts. Old Jud was in form. He laughed, he shouted, he knelt and wept with real tears, he loved everybody, he raced down into the audience and patted shoulders, and for the moment everybody felt that he was closer to them than their closest friends.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rejoiceth as a strong man to run a race,” was his text.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Roberts was really a competent athlete, and he really had skill in evoking pictures. He described the Chicago-Michigan game, and Elmer was lost in him, with him lived the moments of the scrimmage, the long run with the ball, the bleachers rising to him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Roberts voice softened. He was pleading. He was not talking, he said, to weak men who needed coddling into the Kingdom, but to strong men, to rejoicing men, to men brave in armor. There was another sort of race more exhilarating than any game, and it led not merely to a score on a big board but to the making of a new world—it led not to newspaper paragraphs but to glory eternal. Dangerous—calling for strong men! Ecstatic—brimming with thrills! The team captained by Christ! No timid Jesus did he preach, but the adventurer who had joyed to associate with common men, with reckless fishermen, with captains and rulers, who had dared to face the soldiers in the garden, who had dared the myrmidons of Rome and death itself! Come! Who was gallant? Who had nerve? Who longed to live abundantly? Let them come!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They must confess their sins, they must repent, they must know their own weakness save as they were reborn in Christ. But they must confess not in heaven-pilfering weakness, but in training for the battle under the wind-torn banners of the Mighty Captain. Who would come? Who would come? Who was for vision and the great adventure?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was among them, Judson Roberts, with his arms held out, his voice a bugle. Young men sobbed and knelt; a woman shrieked; people were elbowing the standers in the aisles and pushing forward to kneel in agonized happiness, and suddenly they were setting relentlessly on a bewildered Elmer Gantry, who had been betrayed into forgetting himself, into longing to be one with Judson Roberts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His mother was wringing his hand, begging, “Oh, won’t you come? Won’t you make your old mother happy? Let yourself know the joy of surrender to Jesus!” She was weeping, old eyes puckered, and in her weeping was his every recollection of winter dawns when she had let him stay in bed and brought porridge to him across the icy floor; winter evenings when he had awakened to find her still stitching; and that confusing intimidating hour, in the abyss of his first memories, when he had seen her shaken beside a coffin that contained a cold monster in the shape of his father.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The basket-ball player was patting his other arm, begging, “Dear old Hell-cat, you’ve never let yourself be happy! You’ve been lonely! Let yourself be happy with us! You know I’m no mollycoddle. Won’t you know the happiness of salvation with us?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A thread-thin old man, very dignified, a man with secret eyes that had known battles, and mountain-valleys, was holding out his hands to Elmer, imploring with a humility utterly disconcerting, “Oh, come, come with us—don’t stand there making Jesus beg and beg—don’t leave the Christ that died for us standing out in the cold, begging!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And, somehow, flashing through the crowd, Judson Roberts was with Elmer, honoring him beyond all the multitude, appealing for his friendship—Judson Roberts the gorgeous, beseeching:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Are you going to hurt me, Elmer? Are you going to let me go away miserable and beaten, old man? Are you going to betray me like Judas, when I’ve offered you my Jesus as the most precious gift I can bring you? Are you going to slap me and defile me and hurt me? Come! Think of the joy of being rid of all those nasty little sins that you’ve felt so ashamed of! Won’t you come kneel with me, won’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His mother shrieked, “Won’t you, Elmer? With him and me? Won’t you make us happy? Won’t you be big enough to not be afraid? See how we’re all longing for you, praying for you!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes!” from around him, from strangers; and “Help me to follow you, Brother—I’ll go if you will!” Voices woven, thick, dove-white and terrifying black of mourning and lightning-colored, flung around him, binding him—His mother’s pleading, Judson Roberts’ tribute—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("An instant he saw Jim Lefferts, and heard him insist: “Why, sure, course they believe it. They hypnotize themselves. But don’t let ‘em hypnotize you!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He saw Jim’s eyes, that for him alone veiled their bright harshness and became lonely, asking for comradeship. He struggled; with all the blubbering confusion of a small boy set on by his elders, frightened and overwhelmed, he longed to be honest, to be true to Jim—to be true to himself and his own good honest sins and whatsoever penalties they might carry. Then the visions were driven away by voices that closed over him like surf above an exhausted swimmer. Volitionless, marveling at the sight of himself as a pinioned giant, he was being urged forward, forced forward, his mother on one arm and Judson on the other, a rhapsodic mob following.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bewildered. Miserable.… False to Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But as he came to the row kneeling in front of the first pew, he had a thought that made everything all right. Yes! He could have both! He could keep Judson and his mother, yet retain Jim’s respect. He had only to bring Jim also to Jesus, then all of them would be together in beatitude!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Freed from misery by that revelation, he knelt, and suddenly his voice was noisy in confession, while the shouts of the audience, the ejaculations of Judson and his mother, exalted him to hot self-approval and made it seem splendidly right to yield to the mystic fervor.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He had but little to do with what he said. The willing was not his but the mob’s; the phrases were not his but those of the emotional preachers and hysterical worshipers whom he had heard since babyhood:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“O God, oh, I have sinned! My sins are heavy on me! I am unworthy of compassion! O Jesus, intercede for me! Oh, let thy blood that was shed for me be my salvation! O God, I do truly repent of my great sinning and I do long for the everlasting peace of thy bosom!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, praise God,” from the multitude, and “Praise his holy name! Thank God, thank God, thank God! Oh, hallelujah, Brother, thank the dear loving God!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was certain that he would never again want to guzzle, to follow loose women, to blaspheme; he knew the rapture of salvation—yes, and of being the center of interest in the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Others about him were beating their foreheads, others were shrieking, “Lord, be merciful,” and one woman—he remembered her as a strange, repressed, mad-eyed special student who was not known to have any friends—was stretched out, oblivious of the crowd, jerking, her limbs twitching, her hands clenched, panting rhythmically.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But it was Elmer, tallest of the converts, tall as Judson Roberts, whom all the students and most of the townpeople found important, who found himself important.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His mother was crying, “Oh, this is the happiest hour of my life, dear! This makes up for everything!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To be able to give her such delight!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Judson was clawing Elmer’s hand, whooping, “Liked to had you on the team at Chicago, but I’m a lot gladder to have you with me on Christ’s team! If you knew how proud I am!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To be thus linked forever with Judson!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer’s embarrassment was gliding into a robust self-satisfaction.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then the others were crowding on him, shaking his hand, congratulating him: the football center, the Latin professor, the town grocer. President Quarles, his chin whisker vibrant and his shaven upper lip wiggling from side to side, was insisting, “Come, Brother Elmer, stand up on the platform and say a few words to us—you must—we all need it—we’re thrilled by your splendid example!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer was not quite sure how he got through the converts, up the steps to the platform. He suspected afterward that Judson Roberts had done a good deal of trained pushing.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He looked down, something of his panic returning. But they were sobbing with affection for him. The Elmer Gantry who had for years pretended that he relished defying the whole college had for those same years desired popularity. He had it now—popularity, almost love, almost reverence, and he felt overpoweringly his rôle as leading man.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was stirred to more flamboyant confession:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, for the first time I know the peace of God! Nothing I have ever done has been right, because it didn’t lead to the way and the truth! Here I thought I was a good church-member, but all the time I hadn’t seen the real light. I’d never been willing to kneel down and confess myself a miserable sinner. But I’m kneeling now, and, oh, the blessedness of humility!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He wasn’t, to be quite accurate, kneeling at all; he was standing up, very tall and broad, waving his hands; and though what he was experiencing may have been the blessedness of humility, it sounded like his announcements of an ability to lick anybody in any given saloon. But he was greeted with flaming hallelujahs, and he shouted on till he was rapturous and very sweaty:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come! Come to him now! Oh, it’s funny that I who’ve been so great a sinner could dare to give you his invitation, but he’s almighty and shall prevail, and he giveth his sweet tidings through the mouths of babes and sucklings and the most unworthy, and lo, the strong shall be confounded and the weak exalted in his sight!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was all, the Mithraic phrasing, as familiar as “Good morning” or “How are you?” to the audience, yet he must have put new violence into it, for instead of smiling at the recency of his ardor they looked at him gravely, and suddenly a miracle was beheld.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ten minutes after his own experience, Elmer made his first conversion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A pimply youth, long known as a pool-room tout, leaped up, his greasy face working, shrieked, “O God, forgive me!” butted in frenzy through the crowd, ran to the mourner’s bench, lay with his mouth frothing in convulsion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then the hallelujahs rose till they drowned Elmer’s accelerated pleading, then Judson Roberts stood with his arm about Elmer’s shoulder, then Elmer’s mother knelt with a light of paradise on her face, and they closed the meeting in a maniac pealing of")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Draw me nearer, blessed Lord")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To thy precious bleeding side.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer felt himself victorious over life and king of righteousness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But it had been only the devoted, the people who had come early and taken front seats, of whom he had been conscious in his transports. The students who had remained at the back of the church now loitered outside the door in murmurous knots, and as Elmer and his mother passed them, they stared, they even chuckled, and he was suddenly cold. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was hard to give heed to his mother’s wails of joy all the way to her boarding-house.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now don’t you dare think of getting up early to see me off on the train,” she insisted. “All I have to do is just to carry my little valise across the street. You’ll need your sleep, after all this stirrin’ up you’ve had tonight—I was so proud—I’ve never known anybody to really wrestle with the Lord like you did. Oh, Elmy, you’ll stay true? You’ve made your old mother so happy! All my life I’ve sorrowed, I’ve waited, I’ve prayed and now I shan’t ever sorrow again! Oh, you will stay true?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He threw the last of his emotional reserve into a ringing, “You bet I will, Ma!” and kissed her good-night.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He had no emotion left with which to face walking alone, in a cold and realistic night, down a street not of shining columns but of cottages dumpy amid the bleak snow and unfriendly under the bitter stars.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His plan of saving Jim Lefferts, his vision of Jim with reverent and beatific eyes, turned into a vision of Jim with extremely irate eyes and a lot to say. With that vanishment his own glory vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Was I,” he wondered, “just a plain damn’ fool?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jim warned me they’d nab me if I lost my head.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now I suppose I can’t ever even smoke again without going to hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But he wanted a smoke. Right now!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He had a smoke.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It comforted him but little as he fretted on:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There wasn’t any fake about it! I really did repent all these darn’ fool sins. Even smoking—I’m going to cut it out. I did feel the—the peace of God.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But can I keep up this speed? Christ! I can’t do it! Never take a drink or anything—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I wonder if the Holy Ghost really was there and getting after me? I did feel different! I did! Or was it just because Judson and Ma and all those Christers were there whooping it up—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jud Roberts kidded me into it. With all his Big Brother stuff. Prob’ly pulls it everywhere he goes. Jim’ll claim I—Oh, damn Jim, too! I got some rights! None of his business if I come out and do the fair square thing! And they did look up to me when I gave them the invitation! It went off fine and dandy! And that kid coming right up and getting saved. Mighty few fellows ever’ve pulled off a conversion as soon after their own conversion as I did! Moody or none of ‘em. I’ll bet it busts the records! Yes, sir, maybe they’re right. Maybe the Lord has got some great use for me, even if I ain’t always been all I might of been … someways … but I was never mean or tough or anything like that … just had a good time.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jim—what right’s he got telling me where I head in? Trouble with him is, he thinks he knows it all. I guess these wise old coots that’ve written all these books about the Bible, I guess they know more’n one smart-aleck Kansas agnostic!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, sir! The whole crowd! Turned to me like I was an All-American preacher!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Wouldn’t be so bad to be a preacher if you had a big church and—Lot easier than digging out law-cases and having to put it over a jury and another lawyer maybe smarter’n you are.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The crowd have to swallow what you tell ‘em in a pulpit, and no back-talk or cross-examination allowed!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For a second he snickered, but:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not nice to talk that way. Even if a fellow don’t do what’s right himself, no excuse for his sneering at fellows that do, like preachers.… There’s where Jim makes his mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not worthy to be a preacher. But if Jim Lefferts thinks for one single solitary second that I’m afraid to be a preacher because he pulls a lot of gaff—I guess I know how I felt when I stood up and had all them folks hollering and rejoicing—I guess I know whether I experienced salvation or not! And I don’t require any James Blaine Lefferts to tell me, neither!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Thus for an hour of dizzy tramping; now colder with doubt than with the prairie wind, now winning back some of the exaltation of his spiritual adventure, but always knowing that he had to confess to an inexorable Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was after one. Surely Jim would be asleep, and by next day there might be a miracle. Morning always promises miracles.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He eased the door open, holding it with a restraining hand. There was a light on the washstand beside Jim’s bed, but it was a small kerosene lamp turned low. He tiptoed in, his tremendous feet squeaking.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim suddenly sat up, turned up the wick. He was red-nosed, red-eyed, and coughing. He stared, and unmoving, by the table, Elmer stared back.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim spoke abruptly:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You son of a sea-cook! You’ve gone and done it! You’ve been saved! You’ve let them hornswoggle you into being a Baptist witch-doctor! I’m through! You can go—to heaven!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aw, say now, Jim, lissen!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ve listened enough. I’ve got nothing more to say. And now you listen to me!” said Jim, and he spoke with tongues for three minutes straight.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Most of the night they struggled for the freedom of Elmer’s soul, with Jim not quite losing yet never winning. As Jim’s face had hovered at the gospel meeting between him and the evangelist, blotting out the vision of the cross, so now the faces of his mother and Judson hung sorrowful and misty before him, a veil across Jim’s pleading.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer slept four hours and went out, staggering with weariness, to bring cinnamon buns, a wienie sandwich, and a tin pail of coffee for Jim’s breakfast. They were laboring windily into new arguments, Jim a little more stubborn, Elmer ever more irritable, when no less a dignitary than President the Rev. Dr. Willoughby Quarles, chin whisker, glacial shirt, bulbous waistcoat and all, plunged under the fat soft wing of the landlady.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The president shook hands a number of times with everybody, he eyebrowed the landlady out of the room, and boomed in his throaty pulpit voice, with belly-rumblings and long-drawn R’s and L’s, a voice very deep and owlish, most holy and fitting to the temple which he created merely by his presence, rebuking to flippancy and chuckles and the puerile cynicisms of the Jim Leffertses—a noise somewhere between the evening bells and the morning jackass:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, Brother Elmer, that was a brave thing you did! I have never seen a braver! For a great strong man of your gladiatorial powers to not be afraid to humble himself! And your example will do a great deal of good, a grrrrrreat deal of good! And we must catch and hold it. You are to speak at the Y.M.C.A. tonight—special meeting to reenforce the results of our wonderful Prayer Week.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, gee, President, I can’t!” Elmer groaned.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, yes, Brother, you must. You must! It’s already announced. If you’ll go out within the next hour, you’ll be gratified to see posters announcing it all over town!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But I can’t make a speech!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The Lord will give the words if you give the good will! I myself shall call for you at a quarter to seven. God bless you!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer was completely frightened, completely unwilling, and swollen with delight that after long dark hours when Jim, an undergraduate, had used him dirtily and thrown clods at his intellect, the President of Terwillinger College should have welcomed him to that starched bosom as a fellow-apostle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("While Elmer was making up his mind to do what he had made up his mind to do, Jim crawled into bed and addressed the Lord in a low poisonous tone.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer went out to see the posters. His name was in lovely large letters.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For an hour, late that afternoon, after various classes in which every one looked at him respectfully, Elmer tried to prepare his address for the Y.M.C.A. and affiliated lady worshipers. Jim was sleeping, with a snore like the snarl of a leopard.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In his class in Public Speaking, a course designed to create congressmen, bishops, and sales-managers, Elmer had had to produce discourses on Taxation, the Purpose of God in History, Our Friend the Dog, and the Glory of the American Constitution. But his monthly orations had not been too arduous; no one had grieved if he stole all his ideas and most of his phrasing from the encyclopedia. The most important part of preparation had been the lubrication of his polished-mahogany voice with throat-lozenges after rather steady and totally forbidden smoking. He had learned nothing except the placing of his voice. It had never seemed momentous to impress the nineteen students of oratory and the instructor, an unordained licensed preacher who had formerly been a tax-assessor in Oklahoma. He had, in Public Speaking, never been a failure nor ever for one second interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Now, sweating very much, he perceived that he was expected to think, to articulate the curious desires whereby Elmer Gantry was slightly different from any other human being, and to rivet together opinions which would not be floated on any tide of hallelujahs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He tried to remember the sermons he had heard. But the preachers had been so easily convinced of their authority as prelates, so freighted with ponderous messages, while himself, he was not at the moment certain whether he was a missionary who had to pass his surprising new light on to the multitude, or just a sinner who—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Just a sinner! For keeps! Nothing else! Damned if he’d welsh on old Jim! No, sir! Or welsh on Juanita, who’d stood for him and merely kidded him, no matter how soused and rough and mouthy he might be! … Her hug. The way she’d get rid of that buttinsky aunt of Nell’s; just wink at him and give Aunty some song and dance or other and send her out for chow—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("God! If Juanita were only here! She’d give him the real dope. She’d advise him whether he ought to tell Prexy and the Y.M. to go to hell or grab this chance to show Eddie Fislinger and all those Y.M. highbrows that he wasn’t such a bonehead—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("No! Here Prexy had said he was the whole cheese: gotten up a big meeting for him. Prexy Quarles and Juanita! Aber nit! Never get them two together! And Prexy had called on him—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Suppose it got into the newspapers! How he’d saved a tough kid, just as good as Judson Roberts could do. Juanita—find skirts like her any place, but where could they find a guy that could start in and save souls right off the bat?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Chuck all these fool thoughts, now that Jim was asleep, and figure out this spiel. What was that about sweating in the vineyard? Something like that, anyway. In the Bible.… However much they might rub it in—and no gink’d ever had a worse time, with that sneaking Eddie poking him on one side and Jim lambasting him on the other—whatever happened, he had to show those yahoos he could do just as good—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Hell! This wasn’t buying the baby any shoes; this wasn’t getting his spiel done. But—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What was the doggone thing to be about?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Let’s see now. Gee, there was a bully thought! Tell ‘em about how a strong husky guy, the huskier he was the more he could afford to admit that the power of the Holy Ghost had just laid him out cold—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("No. Hell! That was what Old Jud had said. Must have something new—kinda new, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He shouldn’t say “hell.” Cut it out. Stay converted, no matter how hard it was. He wasn’t afraid of—Him and Old Jud, they were husky enough to—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("No, sir! It wasn’t Old Jud; it was his mother. What’d she think if she ever saw him with Juanita? Juanita! That sloppy brat! No modesty!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Had to get down to brass tacks. Now!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer grasped the edge of his work-table. The top cracked. His strength pleased him. He pulled up his dingy red sweater, smoothed his huge biceps, and again tackled his apostolic labors:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Let’s see now: The fellow at the Y. would expect him to say—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He had it! Nobody ever amounted to a darn except as the—what was it?—as the inscrutable designs of Providence intended him to be.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer was very busy making vast and unformed scrawls in a ten-cent-note-book hitherto devoted to German. He darted up, looking scholarly, and gathered his library about him: his Bible, given to him by his mother; his New Testament, given by a Sunday School teacher; his text-books in Weekly Bible and Church History; and one-fourteenth of a fourteen-volume set of Great Orations of the World which, in a rare and alcoholic moment of bibliomania, he had purchased in Cato for seventeen cents. He piled them and repiled them and tapped them with his fountain-pen.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His original stimulus had run out entirely.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Well, he’d get help from the Bible. It was all inspired, every word, no matter what scoffers like Jim said. He’d take the first text he turned to and talk on that.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He opened on: “Now therefore, Tatnai, governor beyond the river, Shethar-boznai, and your companions the Apharsachites, which are beyond the river, be ye far from thence,” an injunction spirited but not at present helpful.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He returned to pulling his luxuriant hair and scratching.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Golly. Must be something.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The only way of putting it all over life was to understand these Forces that the scientists, with their laboratories and everything, couldn’t savvy, but to a real Christian they were just as easy as rolling off a log—")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("No. He hadn’t taken any lab courses except Chemistry I, so he couldn’t show where all these physicists and biologists were boobs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer forlornly began to cross out the lovely scrawls he had made in his note-book.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was irritably conscious that Jim was awake, and scoffing:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Having quite a time being holy and informative, Hell-cat? Why don’t you pinch your first sermon from the heathen? You won’t be the first up-and-coming young messiah to do it!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim shied a thin book at him, and sank again into infidel sleep. Elmer picked up the book. It was a selection from the writings of Robert G. Ingersoll.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer was indignant.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Take his speech from Ingersoll, that rotten old atheist that said—well, anyway, he criticized the Bible and everything! Fellow that couldn’t believe the Bible, least he could do was not to disturb the faith of others. Darn’ rotten thing to do! Fat nerve of Jim to suggest his pinching anything from Ingersoll! He’d throw the book in the fire!")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But—Anything was better than going on straining his brains. He forgot his woes by drugging himself with heedless reading. He drowsed through page on page of Ingersoll’s rhetoric and jesting. Suddenly he sat up, looked suspiciously over at the silenced Jim, looked suspiciously at Heaven. He grunted, hesitated, and began rapidly to copy into the German notebook, from Ingersoll:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Love is the only bow on life’s dark cloud. It is the Morning and the Evening Star. It shines upon the cradle of the babe, and sheds its radiance upon the quiet tomb. It is the mother of Art, inspirer of poet, patrior and philosopher. It is the air and light of every heart, builder of every home, kindler of every fire on every hearth. It was the first to dream of immortality. It fills the world with melody, for Music is the voice of Love. Love is the magician, the enchanter, that changes worthless things to joy, and makes right royal kings and queens of common clay. It is the perfume of the wondrous flower—the heart—and without that sacred passion, that divine swoon, we are less than beasts; but with it, earth is heaven and we are gods.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Only for a moment, while he was copying, did he look doubtful, then:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rats! Chances are nobody there tonight has ever read Ingersoll. Agin him. Besides I’ll kind of change it around.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When President Quarles called for him, Elmer’s exhortation was outlined, and he had changed to his Sunday-best blue serge double-breasted suit and sleeked his hair.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As they departed, Jim called Elmer back from the hall to whisper, “Say, Hell-cat, you won’t forget to give credit to Ingersoll, and to me for tipping you off, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You go to hell!” said Elmer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was a sizable and extremely curious gathering at the Y.M.C.A. All day the campus had debated, “Did Hell-cat really sure-enough get saved? Is he going to cut out his hell-raising?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Every man he knew was present, their gaping mouths dripping question-marks, grinning or doubtful. Their leers confused him, and he was angry at being introduced by Eddie Fislinger, president of the Y.M.C.A.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He started coldly, stammering. But Ingersoll had provided the beginning of his discourse, and he warmed to the splendor of his own voice. He saw the audience in the curving Y.M.C.A. auditorium as a radiant cloud, and he began to boom confidently, he began to add to his outline impressive ideas which were altogether his own—except, perhaps, as he had heard them thirty or forty times in sermons.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It sounded very well, considering. Certainly it compared well with the average mystical rhapsody of the pulpit.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For all his slang, his cursing, his mauled plurals and singulars, Elmer had been compelled in college to read certain books, to hear certain lectures, all filled with flushed, florid polysyllables, with juicy sentiments about God, sunsets, the moral improvement inherent in a daily view of mountain scenery, angels, fishing for souls, fishing for fish, ideals, patriotism, democracy, purity, the error of Providence in creating the female leg, courage, humility, justice, the agricultural methods of Palestine circ. 4 A.D., the beauty of domesticity, and preachers’ salaries. These blossoming words, these organ-like phrases, these profound notions had been rammed home till they stuck in his brain, ready for use.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But even to the schoolboy-wearied faculty who had done the ramming, who ought to have seen the sources, it was still astonishing that after four years of grunting, Elmer Gantry should come out with these flourishes, which they took perfectly seriously, for they themselves had been nurtured in minute Baptist and Campbellite colleges.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Not one of them considered that there could be anything comic in the spectacle of a large young man, divinely fitted for coal-heaving, standing up and wallowing in thick slippery words about Love and the Soul. They sat—young instructors not long from the farm, professors pale from years of napping in unaired pastoral studies—and looked at Elmer respectfully as he throbbed:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s awful’ hard for a fellow that’s more used to bucking the line than to talking publicly to express how he means, but sometimes I guess maybe you think about a lot of things even if you don’t always express how you mean, and I want to—what I want to talk about is how if a fellow looks down deep into things and is really square with God, and lets God fill his heart with higher aspirations, he sees that—he sees that Love is the one thing that can really sure-enough lighten all of life’s dark clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, sir, just Love! It’s the morning and evening star. It’s—even in the quiet tomb, I mean those that are around the quiet tomb, you find it even there. What is it that inspires all great men, all poets and patriots and philosophers? It’s Love, isn’t it? What gave the world its first evidences of immortality? Love! It fills the world with melody, for what is music? What is music? Why! Music is the voice of Love!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The great President Quarles leaned back and put on his spectacles, which gave a slight appearance of learning to his chin-whiskered countenance, otherwise that of a small-town banker in 1850. He was the center of a row of a dozen initiates on the platform of the Y.M.C.A. auditorium, a shallow platform under a plaster half-dome. The wall behind them was thick with diagrams, rather like anatomical charts, showing the winning of souls in Egypt, the amount spent on whisky versus the amount spent on hymn-books, and the illustrated progress of a pilgrim from Unclean Speech through Cigarette smoking and Beer Saloons to a lively situation in which he beat his wife, who seemed to dislike it. Above was a large and enlightening motto: “Be not overcome of evil, but overcome evil with good.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The whole place had that damp-straw odor characteristic of places of worship, but President Quarles did not, seemingly, suffer in it. All his life he had lived in tabernacles and in rooms devoted to thin church periodicals and thick volumes of sermons. He had a slight constant snuffle, but his organism was apparently adapted now to existing without air. He beamed and rubbed his hands, and looked with devout joy on Elmer’s broad back as Elmer snapped into it, ever surer of himself; as he bellowed at the audience—beating them, breaking through their interference, making a touchdown:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What is it makes us different from the animals? The passion of Love! Without it, we are—in fact we are nothing; with it, earth is heaven, and we are, I mean to some extent, like God himself! Now that’s what I wanted to explain about Love, and here’s how it applies. Prob’ly there’s a whole lot of you like myself—oh, I been doing it, I’m not going to spare myself—I been going along thinking I was too good, too big, too smart, for the divine love of the Savior! Say! Any of you ever stop and think how much you’re handing yourself when you figure you can get along without divine intercession? Say! I suppose prob’ly you’re bigger than Moses, bigger than St. Paul, bigger than Pastewer, that great scientist—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("President Quarles was exulting, “It was a genuine conversion! But more than that! Here’s a true discovery—my discovery! Elmer is a born preacher, once he lets himself go, and I can make him do it! O Lord, how mysterious are thy ways! Thou hast chosen to train our young brother not so much in prayer as in the mighty struggles of the Olympic field! I—thou, Lord, hast produced a born preacher. Some day he’ll be one of our leading prophets!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The audience clapped when Elmer hammered out his conclusion: “—and you Freshmen will save a lot of time that I wasted if you see right now that until you know God you know—just nothing!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They clapped, they made their faces to shine upon him. Eddie Fislinger won him by sighing, “Old fellow, you got me beat at my own game like you have at your game!” There was much hand-shaking. None of it was more ardent than that of his recent enemy, the Latin professor, who breathed:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Where did you get all those fine ideas and metaphors about the Divine Love, Gantry?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh,” modestly, “I can’t hardly call them mine, Professor. I guess I just got them by praying.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Judson Roberts, ex-football-star, state secretary of the Y.M.C.A., was on the train to Concordia, Kansas. In the vestibule he had three puffs of an illegal cigarette and crushed it out.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, really, it wasn’t so bad for him, that Elmer what’s-his-name, to get converted. Suppose there isn’t anything to it. Won’t hurt him to cut out some of his bad habits for a while, anyway. And how do we know? Maybe the Holy Ghost does come down. No more improbable than electricity. I do wish I could get over this doubting! I forget it when I’ve got ‘em going in an evangelistic meeting, but when I watch a big butcher like him, with that damn’ silly smirk on his jowls—I believe I’ll go into the real estate business. I don’t think I’m hurting these young fellows any, but I do wish I could be honest. Oh, Lordy, Lordy, Lordy, I wish I had a good job selling real estate!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer walked home firmly. “Just what right has Mr. James B. Lefferts got to tell me I mustn’t use my ability to get a crowd going? And I certainly had ‘em going! Never knew I could spiel like that. Easy as feetball! And Prexy saying I was a born preacher! Huh!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Firmly and resentfully he came into their room, and slammed down his hat.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It awoke Jim. “How’d it go over? Hand ‘em out the gospel guff?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I did!” Elmer trumpeted. “It went over, as you put it, corking. Got any objections?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He lighted the largest lamp and turned it up full, his back to Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("No answer. When he looked about, Jim seemed asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At seven next morning he said forgivingly, rather patronizingly, “I’ll be gone till ten—bring you back some breakfast?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim answered, “No, thanks,” and those were his only words that morning.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When Elmer came in at ten-thirty, Jim was gone, his possessions gone. (It was no great moving: three suitcases of clothes, an armful of books.) There was a note on the table:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I shall live at the College Inn the rest of this year. You can probably get Eddie Fislinger to live with you. You would enjoy it. It has been stimulating to watch you try to be an honest roughneck, but I think it would be almost too stimulating to watch you become a spiritual leader.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body- ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("J. B. L.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("All of Elmer’s raging did not make the room seem less lonely.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d551a788","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElmerGantry-5.vue
// module id = 72
// module chunks = 0